module.exports = __webpack_public_path__ + "static/media/clients-01.b9978201.svg";